import styled from 'styled-components';
import theme from 'styles/theme';

export type ValueSize = 'medium' | 'large';

export const DisplayValueContainer = styled.div<{ $valueSize: ValueSize }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 32px;

  .display-label {
    font-size: 16px;
  }

  .display-value {
    font-size: ${({ $valueSize }) =>
      $valueSize === 'medium' ? '16px' : '20px'};
    font-weight: 600;
    display: flex;
    flex-direction: column;
    gap: 4px;
    align-items: flex-end;
  }

  .display-value-helper {
    font-size: 13px;
    font-weight: 400;
  }

  padding: 8px 0;
  border-top: 1px solid ${theme.colors.gray300};

  &:last-child {
    border-bottom: 1px solid ${theme.colors.gray300};
  }
`;
